var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Menu } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { SearchableMenuBody, SearchableMenuMultiSelectList, SearchableMenuProvider, SearchableMenuSearchHeader, useSearchableMenuFuse, } from 'shared/domains/common-ui/SearchableMenu';
import { ListSelectionAddItem } from './ListSelectionAddItem';
import { ListSelectionListItem } from './ListSelectionListItem';
import { RemoveSelection } from './RemoveSelection';
import { SubmitSelection } from './SubmitSelection';
export function ListSelection(props) {
    const { label, items, isMultiSelect, loading, reference, addOnNoMatch } = props;
    const { submitForm } = useFormikContext();
    const [field, , helpers] = useField('value');
    const search = useSearchableMenuFuse(items, {
        keys: ['text', 'groupValues.text'],
    });
    const currentValues = field.value;
    const isSelected = (value) => {
        const valueArr = Array.isArray(currentValues) ? currentValues : [currentValues];
        return valueArr.includes(value);
    };
    const getNewValues = (newValue) => {
        const selected = isSelected(newValue);
        if (!isMultiSelect) {
            return newValue;
        }
        if (selected) {
            return currentValues.filter((selectedValue) => selectedValue !== newValue);
        }
        return [...currentValues, newValue];
    };
    const handleSelect = (value) => __awaiter(this, void 0, void 0, function* () {
        const newValues = getNewValues(value);
        helpers.setValue(newValues);
        if (!isMultiSelect) {
            return submitForm();
        }
        return undefined;
    });
    return (<Menu.ItemNested target={label} loading={loading}>
      <SearchableMenuProvider {...search}>
        <SearchableMenuSearchHeader />
        <SearchableMenuBody>
          {addOnNoMatch && <ListSelectionAddItem items={items} onAdd={handleSelect}/>}
          <SearchableMenuMultiSelectList renderListWrapper={false} renderItem={(item) => (<ListSelectionListItem item={item} reference={reference} selected={isSelected(item.value)} handleSelect={handleSelect}/>)}/>
        </SearchableMenuBody>
        <Menu.Footer sticky withoutPadding>
          {isMultiSelect && <SubmitSelection />}
          <RemoveSelection />
        </Menu.Footer>
      </SearchableMenuProvider>
    </Menu.ItemNested>);
}
